import { ReactNode } from "react";
import { Animation } from "rsuite";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretDown } from "@fortawesome/free-solid-svg-icons";

export const CollapseFilter = ({
  title,
  showComponent,
  children,
  setShowComponent,
  keyWord,
  active,
}: {
  title: string;
  showComponent: boolean;
  setShowComponent: any;
  children: ReactNode;
  keyWord: "addres" | "case" | "perspectives" | "dates" | "jurisprudence";
  active: boolean;
}) => {
  <div
    style={{
      width: "100%",
      height: "100%",
      position: "relative",
      boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
      border: "1px black solid",
    }}
  >
    <div
      style={{
        width: 2462,
        height: 111.38,
        left: 0,
        top: 16.62,
        position: "absolute",
        background:
          "linear-gradient(180deg, #A42F2F 69%, rgba(184, 28, 7, 0) 100%)",
        boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
      }}
    />
    <div
      style={{
        width: 427.12,
        height: 114.7,
        left: 29.52,
        top: 0,
        position: "absolute",
        color: "white",
        fontSize: 20,
        fontFamily: "Inter",
        fontWeight: "900",
        wordWrap: "break-word",
      }}
    >
      Archivo
    </div>
  </div>;

  return (
    <div className="d-flex justify-content-center">
      <div className="mt-3 border" style={{ width: "98%" }}>
        <div>
          <div
            className="d-flex flex-row align-items-center justify-content-between p-3"
            style={
              active === true
                ? {
                    background:
                      "linear-gradient(180deg, #A42F2F 69%, rgba(184, 28, 7, 0) 100%)",
                    // boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
                    color: "white",
                  }
                : {
                    color: "white",
                    background:
                      "linear-gradient(180deg, #585657 79%, rgba(226, 227, 227, 0) 100%)",
                  }
            }
          >
            <h5>{title}</h5>
            <FontAwesomeIcon
              icon={faCaretDown}
              rotation={showComponent ? undefined : 270}
              onClick={() => {
                setShowComponent(keyWord, !showComponent);
              }}
              style={{ cursor: "pointer", color: "white" }}
              size="xl"
            />
          </div>
        </div>
        <Animation.Collapse in={showComponent}>
          {(props, ref) => (
            <div
              ref={ref}
              {...props}
              // className={showForm && "border border-dark rounded"}
            >
              {children}
            </div>
          )}
        </Animation.Collapse>
      </div>
    </div>
  );
};
